import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
import CloseIcon from '@/assets/icon/close.svg';
import MapIcon from '@/assets/icon/ic_map.svg';
import MenuIcon from '@/assets/icon/ic_menu.svg';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
export default function ListMapHeader({ viewMode, title, onToggleViewMode, onClose, toggleElementName, closeElementName, closeIconSize = 16, }) {
    return (_jsxs(HeaderRow, { "$isMapMode": viewMode === 'map', children: [_jsxs(HeaderLeftToggle, { elementName: toggleElementName, activeOpacity: 0.8, onPress: onToggleViewMode, children: [viewMode === 'list' ? (_jsx(MapIcon, { width: 24, height: 24, color: color.black })) : (_jsx(MenuIcon, { width: 24, height: 24, color: color.black })), _jsx(HeaderToggleText, { children: viewMode === 'list' ? '지도' : '목록' })] }), _jsx(HeaderTitle, { numberOfLines: 1, children: title }), _jsx(SccTouchableOpacity, { elementName: closeElementName, activeOpacity: 0.8, hitSlop: 14, onPress: onClose, children: _jsx(CloseIcon, { width: closeIconSize, height: closeIconSize, color: color.black }) })] }));
}
const HeaderRow = styled.View `
  flex-direction: row;
  align-items: center;
  padding-horizontal: 20px;
  padding-vertical: 7px;
  gap: 12px;
  background-color: ${color.white};
`;
const HeaderLeftToggle = styled(SccTouchableOpacity) `
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 38px;
`;
const HeaderToggleText = styled.Text `
  font-size: 10px;
  font-family: ${font.pretendardRegular};
  color: ${color.black};
`;
const HeaderTitle = styled.Text `
  flex: 1;
  font-size: 18px;
  font-family: ${font.pretendardSemibold};
  color: ${color.black};
`;
